export default __webpack_public_path__ + "static/media/watches5.e83626d5.jfif";